import { useQuery } from '@tanstack/react-query'
import keys from './keys'

export const usePlanMove = (planIdFrom: number, planIdTo: number) => {
  return useQuery(keys.plan_move.detail(planIdFrom, planIdTo))
}
